(() => {
  function addWorkingDays(startDate, numberOfDays) {
    const date = new Date(startDate);
    let added = 0;
    while (added < numberOfDays) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
    }
    return date;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    }).format(date);
  }

  function initialise(container) {
    if (!container || container.dataset.opsInitialised === 'true') return;
    container.dataset.opsInitialised = 'true';

    const minDays = Math.max(1, Number(container.dataset.dispatchMin) || 3);
    const maxDays = Math.max(minDays, Number(container.dataset.dispatchMax) || 5);
    const dispatch = container.querySelector('[data-ops-dispatch-date]');
    if (dispatch) {
      const now = new Date();
      if (minDays === maxDays) {
        dispatch.textContent = `by ${formatDate(addWorkingDays(now, maxDays))}`;
      } else {
        dispatch.textContent = `${formatDate(addWorkingDays(now, minDays))}–${formatDate(addWorkingDays(now, maxDays))}`;
      }
    }
  }

  function initialiseAll(root = document) {
    root.querySelectorAll?.('[data-ops-product-trust]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  document.addEventListener('shopify:block:select', (event) => initialiseAll(event.target));
})();
